<template>
  <div class="Detail" @click="removeUserPopup">
    <!-- s: header -->
    <header id="header-slidePanel">
      <h2>{{ boardDetail.detail.oMenu.strMenuName }}</h2>
      <div class="btn_back">
        <a @click="slidePanelClose('reload')">
          <img src="@/assets/images/btn_back.png" width="50" alt="이전"/>
        </a>
      </div>
    </header>
    <!-- e: header -->
    <!-- s: contents -->
    <div class="contents-area-slidePanel" @click="popupOpt=false">
      <div v-infinite-scroll="getReplyList"
           infinite-scroll-disabled="loading"
           infinite-scroll-distance="300">
        <h1 class="mrg-top-15">
          <!-- 질문글 표시 -->
          <span class="iconQuestion"
                v-if="boardDetail.detail.oBoard && boardDetail.detail.oBoard.oKnowledgeIn.bKnowledgeIn"
                :class="'iconKonw_'+boardDetail.detail.oBoard.oKnowledgeIn.strKnowledgeInStatus">
            {{boardDetail.detail.oBoard.oKnowledgeIn.strKnowledgeInStatus | filterStrKnowledgeInStatusName}}</span>
          {{ boardDetail.detail.oBoard.strBoardTitle }}
        </h1>
        <div class="detail-info clearfix">
          <!-- s: 사용자정보 -->
          <div class="user-photo" v-if="boardSetting.bShowUserPhoto">
            <img :src="boardDetail.detail.oUser.strProfileImg" width="100%"/>
          </div>
          <!-- 등록일 / 조회수 / 추천수 -->
          <div class="user-info" v-if="boardSetting.bShowUserInfo">
            <p class="name">{{ boardDetail.detail.oUser.strNickName }}</p>
            <div class="info">
              <span class="time">{{ boardDetail.detail.oBoard.strRegDate }}</span>
              <span class="readcnt">{{ boardDetail.detail.oBoard.nViewCnt | comma }}</span>
              <span class="like">{{ boardDetail.detail.oBoard.nRecomCnt | comma }}</span>
            </div>
          </div>
          <!-- e: 사용자정보 -->
          <!-- 댓글보기 -->
          <a href="#focus-comment-area" v-if="boardSetting.bShowReplyArea">
            댓글보기
          </a>
          <!-- s: 게시글 옵션 -->
          <div class="option" :class="{ on: popupOpt }">
            <button class="btn_option"
                    @click.stop="(popupOpt == true) ? popupOpt=false : popupOpt=true"
                    v-if="boardDetail.detail.oUser.strUserId == $store.state.userId || boardSetting.bShowBoardOption">
              옵션
            </button>
            <div class="option_popup">
              <ul>
                <li v-if="boardDetail.detail.oBoard.bMyRegistrationBoard == true ">
                  <a @click="boardWriteSlideView(boardSeq)">
                    수정
                  </a>
                </li>
                <li v-if="boardDetail.detail.oBoard.bMyRegistrationBoard == true ">
                  <a @click="DelBoard()">
                    삭제
                  </a>
                </li>
                <template v-if="boardSetting.bShowBoardOption">
                  <li v-if="boardDetail.detail.oUser.strUserId != $store.state.userId ">
                    <a @click="singoSlideView">신고</a>
                  </li>
                  <li>
                    <a @click="popupOpt=false; copyUrl(boardDetail.detail.oBoard.strWebUrl)">
                      URL복사
                    </a>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <!-- e: 게시글 옵션 -->
        </div>

        <!-- 게시글 내용 -->
        <div class="contents" v-html="boardDetail.detail.oBoard.strContent"></div>

        <!-- s: 설문지 -->
        <div class="poll" v-if="boardDetail.oPoll && boardDetail.oPoll.list">
          <ul class="poll_list">
            <li class="poll"
                v-for="(data, index) in boardDetail.oPoll.list"
                :key="index">
              <h4>
                <strong>설문 {{ index + 1 }}.</strong>
                {{ data.Poll }}
                <small>(총 <strong>{{ data.VoteCnt }}</strong>명 참여)</small>
              </h4>
              <!-- 투표하기 -->
              <template v-if="data.Join == 'N'">
                <ul class="item_list">
                  <li class="item"
                      v-for="item in data.Item"
                      :key="item.Num">
                    <!-- 단일선택 -->
                    <label class="rad"
                           v-if="data.Dupl == 'N'">
                      <input type="radio"
                             :value="item.Num"
                             v-model="data.checked"/>
                      <i></i>
                      {{ item.Name }}
                    </label>
                    <!-- 복수선택 -->
                    <label class="ckb square" v-else>
                      <input type="checkbox"
                             :true-value="item.Num"
                             v-model="item.checked"/>
                      <i></i>
                      {{ item.Name }}
                    </label>
                  </li>
                </ul>
              </template>
              <!-- 투표완료 -->
              <template v-else>
                <table class="vote_result">
                  <tbody>
                  <tr class="item"
                      v-for="item in data.Item"
                      :key="item.Num">
                    <td class="name">{{ item.Name }}</td>
                    <td class="bar">
                      <div class="bg">
                        <div class="bar"
                             :class="data.Color"
                             :style="'width:'+ ((data.VoteCnt == 0) ? 0 : (item.VoteCnt / data.VoteCnt)*100)+'%;' "></div>
                      </div>
                    </td>
                    <td class="cnt">
                      {{ (data.VoteCnt == 0) ? 0 : ((item.VoteCnt / data.VoteCnt) * 100) | round }}%
                      ({{ item.VoteCnt }}명)
                    </td>
                  </tr>
                  </tbody>
                </table>
              </template>
            </li>
          </ul>
          <div class="width-100 text-center mrg-top-50"
               v-if="boardDetail.oPoll.list[0].Join == 'N'">
            <button class="btn-poll"
                    @click="surverSend">
              투표하기
            </button>
          </div>
        </div>
        <!-- e: 설문지 -->

        <!-- s: like -->
        <div class="like-area" v-if="boardSetting.bShowRecommend">
          <button class="btn-like"
                  @click="setBoardRecommend">
            {{ boardDetail.detail.oBoard.nRecomCnt | comma }}
          </button>
        </div>
        <!-- e: like -->

        <!-- s: 첨부파일 다운로드 -->
        <ul class="fileAttachment"
            v-if="boardDetail.oFile && boardDetail.oFile.list">
          <li v-for="(data, index) in boardDetail.oFile.list"
              :key="index">
            <a v-if="mobileOs == 'ios'"
               @click="fileDownload('https://community-api.mobigo.co.kr/api/v1/board/file/download/'+data.arrFileInfo.nFileNum+'/'+data.arrFileInfo.strFileCode)">
              {{ data.strFileName }}
              <!-- 첨부파일 사이즈 -->
              <p>{{ data.nFileSizeK | getfileSize }}</p>
            </a>
            <a v-else
               :href="'https://community-api.mobigo.co.kr/api/v1/board/file/download/'+data.arrFileInfo.nFileNum+'/'+data.arrFileInfo.strFileCode"
               :download="data.strFileName">
              {{ data.strFileName }}
              <!-- 첨부파일 사이즈 -->
              <p>{{ data.nFileSizeK | getfileSize }}</p>
            </a>
          </li>
        </ul>
        <!-- e: 첨부파일 다운로드 -->

        <!-- s: 댓글영역 -->
        <div class="comment-area"
             id="focus-comment-area"
             v-if="boardSetting.bShowReplyArea">
          <h5>댓글 <strong> {{ replyTotalCnt }} 개</strong></h5>
          <h6 class="strTextForCommentInfo"
              v-if="strTextForCommentInfo"
              v-html="strTextForCommentInfo">
          </h6>

          <ul v-if="replyInfo.length > 0">
            <li v-for="(data, index) in replyInfo" :key="index">
              <Comment :oReply="data.oReply"
                       :oUser="data.oUser"
                       :boardId="boardId"
                       :boardSeq="boardSeq"
                       :cidx="index"
                       @deleteComment="removeComment"
                       @sendToRegForm="setFormReply"></Comment>
            </li>
          </ul>
        </div>
        <!-- 댓글영역 : e -->
        <!-- 댓글 작성 : e -->
        <div class="page-area">
          <div>
            <button class="prev"
                    :class="(!oMovePageInfo.oPrevPage.bExistence) ? 'off' : ''"
                    @click="(oMovePageInfo.oPrevPage.bExistence) ? boardDetailMove(prevPage) : null">
              이전 글
            </button>
          </div>
          <div>
            <button class="next"
                    :class="(!oMovePageInfo.oNextPage.bExistence) ? 'off' : ''"
                    @click="(oMovePageInfo.oNextPage.bExistence) ? boardDetailMove(nextPage) : null">
              다음 글
            </button>
          </div>
          <div>
            <button @click="slidePanelClose">목록</button>
          </div>
        </div>
      </div>
    </div>
    <!-- e: contents -->
    <!-- s: 하단 메뉴 -->
    <footer class="footer-board">
      <!-- 댓글 작성 : s -->
      <div class="footer-reply">
        <ReplyRegForm v-if="boardSetting.bShowReplyArea"
                      :oProfile="oProfile"
                      :pBoardId="boardId"
                      :pBoardSeq="boardSeq"
                      :nParentReplyNum="0"
                      ref="replyform"
                      @reloadReply="reloadReplyList"></ReplyRegForm>
      </div>
      <ul>
        <li><a @click="homeMove"><img src="@/assets/images/bottom-tab-home.png"/></a></li>
        <li><a @click="init(boardSeq)"><img src="@/assets/images/bottom-tab-refresh.png"/></a></li>
        <li><a @click="boardTop('Y')"><img src="@/assets/images/bottom-tab-top.png"/></a></li>
        <li><a @click="boardSearchSlideView"><img src="@/assets/images/bottom-tab-search.png"/></a></li>
        <li><a @click="boardWriteAuthCheck('')"><img src="@/assets/images/bottom-tab-write.png"/></a></li>
      </ul>
    </footer>
    <!-- e: 하단 메뉴 -->
  </div>
</template>

<script>
import EventBus from "@/plugins/eventBus";
import ReplyRegForm from "@/views/board/ReplyRegForm";
import Comment from "@/views/board/Comment";

Array.prototype.insert = function(value , index){
  const tmp = this.slice( 0 , index ).concat( [value] , this.slice(index ) )
  this.splice(0)
  this.push(...tmp)
}


export default {
  name: 'Detail',
  props: ['pBoardId', 'pBoardSeq'],
  components: {
    Comment,
    ReplyRegForm,
  },
  data() {
    return {
      isSending: false,                // 전송체크
      loading: false,                  // 로딩여부
      page: 1,                         // 페이지상태
      boardId: '',                     // 게시판 순번
      boardSeq: '',                    // 게시글 순번
      boardDetail: {                   // 게시글 상세정보
        detail: {
          oBoard: {
            oKnowledgeIn: {}     // 지식인 글 관련
          },
          oMenu: {},               // 메뉴정보
          oUser: {},               // 작성자 정보
        },
        oFile: [],                   // 업로드 파일 정보
        oPoll: {},                  // 설문조사
      },
      boardSetting: {                  // 게시글 설정
        bShowBoardOption: false,    // 게시글 옵션[신고, URL 복사] 기능 노출 여부 ( true = 노출 / false = 비노출 :: FAQ 인 경우, false 넘어감 )
        bShowRecommend: false,      // 게시글 하단 추천 버튼 노출 여부 ( true = 노출 / false = 비노출 :: FAQ 인 경우, false 넘어감 )
        bShowReplyArea: false,      // 댓글 영역 노출 여부 ( true = 노출 / false = 비노출 :: FAQ 인 경우, false 넘어감 )
        bShowUserInfo: false,       // 작성자 별명, 작성일, 노출수, 추천수 노출 여부 ( true = 노출 / false = 비노출 :: FAQ 인 경우, false 넘어감 )
        bShowUserPhoto: false       // 작성자 프로필 이미지 노출 여부 ( true = 노출 / false = 비노출 :: FAQ 인 경우, false 넘어감 )
      },
      oProfile: {
        oUser: {
          profileImg: ''           // 프로필 이미지
        }
      },
      oMovePageInfo: {
        oPrevPage: {                // 이전글 내역
          bExistence: false,      // 이전글이 있다면 : true , 없다면 : false
          info: {
            oMenu: {
              nMenuNum: ''
            },
            oBoard: {
              BoardNum: ''
            }
          }
        },
        oNextPage: {                // 다음글  내역
          bExistence: false,      // 다음글이 있다면 : true , 없다면 : false
          info: {
            oMenu: {
              nMenuNum: ''    // 메뉴 고유번호
            },
            oBoard: {
              nBoardNum: ''   // 게시글 고유번호
            }
          }
        }
      },
      prevPage: '',                // 이전글 내역
      nextPage: '',                // 다음글 내역
      replyInfo: [],               // 댓글 리스트
      replyMore: true,             // 댓글 다음 내역 유무
      replyClear : true,          // 댓글내역 초기화여부
      replyTotalCnt: 0,            // 댓글 전체 수
      strReplyContent: "",         // 댓글 textarea 정보
      popupOpt: false,             // 게시글 수정, 삭제, 신고, url 옵션 팝업
      strTextForCommentInfo: '',   // 지식IN 관련 안내 문구 추가
    }
  },
  // 계산된 속성
  computed: {
    mobileOs: function () {
      let uAgent = navigator.userAgent.toLocaleLowerCase();
      // Android
      if (uAgent.indexOf("mobigo_android") != -1) {
        return 'android';
        // IOS
      } else if (uAgent.indexOf("mobigo_ios") != -1) {
        return 'ios';
      } else {
        return 'etc';
      }
    },
  },
  // 감시자
  watch: {},
  // $el 생성전
  created() {
    this.boardId = this.pBoardId;
    this.boardSeq = this.pBoardSeq;
    this.init(this.boardSeq);
  },
  // $el 생성후
  mounted() {
    window.callbackBackKey = this.callbackBackKey;
  },
  methods: {
    setFormReply(data) {
      this.$refs.replyform.clearReplyComment()
      this.$refs.replyform.initForm(data)
    },
    // APP 뒤로가기
    callbackBackKey() {
      this.slidePanelClose();
    },
    // 게시글 새로고침
    boardDetailReload() {
      this.init(this.boardSeq);
    },
    // 초기 실행
    init(boardSeq) {
      this.boardSeq = boardSeq;
      this.page = 1;
      this.loading = false;
      this.replyTotalCnt = 0;
      this.replyMore = true;
      this.replyClear = true;
      this.getBoardDetail();
    },
    // 게시글 상세
    getBoardDetail() {
      let param = {};
      let boardActiveCode = this.boardId;
      let boardSeq = this.boardSeq;
      this.ajaxGetAuth('/api/v1/board/detail/' + boardActiveCode + '/' + boardSeq, param, this.getBoardDetailResult);
    },
    // 게시글 상세 결과
    getBoardDetailResult(response) {
      if (response.result.code == 0) {

        if( Object.prototype.hasOwnProperty.call(response, "oEmoticon")){
          this.$store.commit('setEmoticon',response.oEmoticon);
        }

        this.boardDetail.detail.oBoard = response.oBoardInfo.detail.oBoard;
        this.boardDetail.detail.oMenu = response.oBoardInfo.detail.oMenu;
        this.boardDetail.detail.oUser = response.oBoardInfo.detail.oUser;
        this.oProfile = response.oProfile;
        this.boardDetail.oPoll = response.oBoardInfo.oPoll;
        this.boardDetail.oFile = response.oBoardInfo.oFile;
        this.boardSetting = response.oBoardInfo.setting;

        // 댓글 영역 노출 여부
        if (this.boardSetting.bShowReplyArea) {
          this.getReplyList();
        } else {
          document.querySelector('.detail-info').style.padding = "15px 0px 0px 0px";
          document.querySelector('.detail-info').style.marginBottom = "0px";
        }
        this.oMovePageInfo = response.oMovePageInfo;
        this.prevPage = response.oMovePageInfo.oPrevPage.info.oBoard.nBoardNum;
        this.nextPage = response.oMovePageInfo.oNextPage.info.oBoard.nBoardNum;
      } else {
        this.slidePanelClose();
        this.toastMsg(response.result.resultNoti.message, 1500);
      }
    },
    removeComment(idx) {
      this.replyInfo.splice(idx, 1);
    },
    DelBoard() {
      this.mintConfirm('게시글을 삭제 하시겠습니까?', 'setBoardDel')
    },
    // 게시글 삭제
    setBoardDel() {
      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }

      this.isSending = true;

      let boardActiveCode = this.boardId;
      let boardSeq = this.boardSeq;
      let formData = new FormData();
      this.ajaxPostAuth('/api/v1/board/delete/' + boardActiveCode + '/' + boardSeq, formData, this.setBoardDelResult);
    },
    // 게시글 삭제 결과
    setBoardDelResult() {
      this.isSending = false;

      EventBus.$emit('reload-board-list', '');
      this.slidePanelClose();
    },
    // 투표하기
    surverSend() {
      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }

      this.isSending = true;

      let oPollData = [];
      // 투표정보
      this.boardDetail.oPoll.list.forEach(function (key) {
        // 복수선택
        if (key.Dupl == 'Y') {
          let checkData = [];
          key.Item.forEach(function (item) {
            if (item.checked) {
              checkData.push(item.checked)
            }
          })
          oPollData.push({"Num": key.Num, "Item": checkData})
          // 단일선택
        } else {
          let radioData = [];
          if (key.checked) {
            radioData.push(key.checked)
          }
          oPollData.push({"Num": key.Num, "Item": radioData})
        }
      })

      let boardActiveCode = this.boardId;
      let boardSeq = this.boardSeq;

      let formData = new FormData();
      formData.append('oPollData', JSON.stringify(oPollData));
      this.ajaxPostAuth('/api/v1/board/poll/vote/' + boardActiveCode + '/' + boardSeq, formData, this.surveySendResult);
    },
    // 투표하기 결과
    surveySendResult(response) {
      this.isSending = false;

      this.toastMsg(response.result.resultNoti.message, 1500);
      if (response.result.code == 0) {
        this.init(this.boardSeq);
      }
    },

    reloadReplyList: function() {
      this.loading = false
      this.replyMore = true
      this.replyClear = true
      this.page = 1
      this.getReplyList()
    },
    // 댓글 리스트
    getReplyList() {
      // 댓글 영역 노출 여부
      if (!this.boardSetting.bShowReplyArea) {
        console.log('댓글영역 잠금')
        return false;
      }
      if (!this.replyMore) {
        console.log('댓글조회로 인한 잠금')
        return false;
      }
      this.loading = true;
      let boardActiveCode = this.boardId;
      let boardSeq = this.boardSeq;

      let param = {};
      param.page = this.page;
      const url = '/api/v1/reply/list/' + boardActiveCode + '/' + boardSeq + '/' + this.page

      this.ajaxGetAuth(url, param, this.getReplyListResult);
      this.page++
    },
    // 댓글 리스트 결과
    getReplyListResult(response, varParam) {
      if (response.result.code == 0) {

        if( Object.prototype.hasOwnProperty.call(response, "oEmoticon")){
          this.$store.commit('setEmoticon',response.oEmoticon);
        }

        if (response.oReplyInfo == null) {
          this.replyMore = false;
        } else {
          if (response.oReplyInfo.setting.nMaxPage == varParam.page || response.oReplyInfo.setting.nMaxPage == 0) {
            this.replyMore = false;
          }
          this.replyTotalCnt = response.oReplyInfo.setting.nReplyTotalCnt;

          if (varParam.page === 1) {
            this.strTextForCommentInfo = response.oReplyInfo.setting.strTextForCommentInfo;
          }
          let tmpReplyInfo
          if( this.replyClear ){
            tmpReplyInfo = []
          } else {
            tmpReplyInfo = this.replyInfo.slice(0)
          }
          response.oReplyInfo.list.forEach(function (key) {
            tmpReplyInfo.push(key)
          })
          this.replyInfo = tmpReplyInfo
        }
      } else {
        this.toastMsg(response.result.resultNoti.message, 1500);
      }
      this.loading = false;
      this.replyClear = false;
    },
    // 이전글, 다음글 이동
    boardDetailMove(boardSeq) {
      this.init(boardSeq);
    },
    // 게시글 추천
    setBoardRecommend() {
      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }

      this.isSending = true;

      let param = {};
      let boardActiveCode = this.boardId;
      let boardSeq = this.boardSeq;
      this.ajaxGetAuth('/api/v1/board/recommend/' + boardActiveCode + '/' + boardSeq, param, this.setBoardRecommendResult);
    },
    // 게시글 추천 결과
    setBoardRecommendResult(response) {
      this.isSending = false;
      if (response.result.code == 4000) {
        this.boardDetail.detail.oBoard.nRecomCnt = this.boardDetail.detail.oBoard.nRecomCnt + 1;
      }
      this.toastMsg(response.result.resultNoti.message, 1500, 'middle');
    },
    // 신고 Slide
    singoSlideView() {
      let props = {
        pBoardActiveCode: this.boardId,
        pBoardSeq: this.boardSeq
      };
      const panel = this.$showPanel({
        component: () => import('@/views/board/Singo'),
        props: props,
        openOn: 'right',
        width: screen.width,
      });
      panel.promise.then(result => {
        window.callbackBackKey = this.callbackBackKey;
        if (result.result === "close") {
          this.slidePanelClose(result);
        }
      });
    },
    // 홈으로 이동
    homeMove() {
      this.slidePanelClose();
      this.gotoLink('/Main')
    }
  },
  // $el 해체
  destroyed() {
    this.storageRemove('pageInfo');
  }
}
</script>

<style scoped>
.contents-area-slidePanel {
  bottom: 96px;
}

.Detail h3 {
  position: relative;
  display: inline-block;
  font-size: 13px
}

.Detail h3:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50%;
  background-color: rgba(0, 135, 255, 0.2);
}

.Detail h1 {
  font-size: 21px;
  position: relative;
}

.Detail h1 span.iconQuestion {
  width: 62px;
  display: inline-block;
}

.detail-info {
  padding: 15px 0 30px 0;
  border-bottom: 1px solid #efefef;
  margin-bottom: 30px;
  position: relative;
}

.detail-info .user-photo {
  float: left;
  display: inline-block;
  width: 42px
}

.detail-info .user-photo img {
  border-radius: 7px;
  float: left;
}

.detail-info .user-info {
  display: inline-block;
  padding-left: 12px
}

.detail-info .user-info .name {
  color: #000;
  font-size: 14px;
  font-weight: 500;
}

.detail-info .user-info .info {
  color: #737373;
  font-size: 12px;
  font-weight: 400;
  padding-top: 3px;
}

.detail-info .user-info .info span {
  position: relative;
  margin-right: 10px;
}

.detail-info .user-info .info .time {
  padding-left: 7px;
}

.detail-info .user-info .info .time:after {
  content: "";
  background-image: url("../../assets/images/icon-time.png");
  width: 4px;
  height: 4px;
  background-size: 4px 4px;
  background-repeat: no-repeat;
  position: absolute;
  top: 4px;
  left: 0px
}

.detail-info .user-info .info .readcnt {
  padding-left: 18px;
}

.detail-info .user-info .info .readcnt:after {
  content: "";
  background-image: url("../../assets/images/icon-readcnt.png");
  width: 15px;
  height: 9px;
  background-size: 15px 9px;
  background-repeat: no-repeat;
  position: absolute;
  top: 2px;
  left: 0px
}

.detail-info .user-info .info .like {
  padding-left: 17px;
}

.detail-info .user-info .info .like:after {
  content: "";
  background-image: url("../../assets/images/icon-like.png");
  width: 13px;
  height: 11px;
  background-size: 13px 11px;
  background-repeat: no-repeat;
  position: absolute;
  top: 1px;
  left: 0px
}

.detail-info > a {
  position: absolute;
  right: 0;
  background: transparent;
  top: 37px;
  font-weight: 500;
  color: #0086ff;
  font-size: 14px;
  padding-right: 10px;
}

.detail-info > a:after {
  content: "";
  display: block;
  width: 6px;
  height: 6px;
  border-top: 1px solid #0086ff;
  border-right: 1px solid #0086ff;
  transform: rotate(45deg);
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -4px;
}

.detail-info > .option {
  top: 10px
}

.Detail > .contents-area-slidePanel > div > .contents {
  word-break: break-all;
}

.Detail > .contents-area-slidePanel > div > .contents img {
  min-width: auto;
  width: 100%;
}

.Detail > .contents-area-slidePanel > div > .like-area {
  padding: 45px;
  text-align: center;
  position: relative;
}


.Detail > .contents-area-slidePanel > div > .like-area > .btn-like {
  background-image: url("../../assets/images/icon-like-big.png");
  background-repeat: no-repeat;
  background-size: 25px 23px;
  background-position: 20px 9px;
  width: 108px;
  height: 50px;
  line-height: 10px;
  background-color: #fff;
  border: 2px solid #0086ff;
  border-radius: 50px;
  font-size: 19px;
  font-weight: 500;
  color: #0086ff;
  padding-left: 30px;
  display: inline-block;
  outline: unset;
}

.Detail > .contents-area-slidePanel > div > .like-area > .btn-like:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.option {
  position: absolute;
  right: -10px;
  top: 35px;
  font-weight: 500;
  font-size: 11px;
  color: #999;
}

.option .btn_option {
  width: 26px;
  height: 22px;
  background: url('../../assets/images/btn_option_01_on.jpg') center 0 no-repeat;
  background-size: 16px 22px;
  border: 0;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  text-indent: -999px;
  vertical-align: middle;
  outline: unset
}

.option .btn_option:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.option .option_popup {
  display: none;
  position: absolute;
  right: 0;
  top: 22px;
  background-color: #0086ff;
  border-radius: 5px;
  border-top-right-radius: 0;
  z-index: 1;
}

.option .option_popup li a {
  display: block;
  line-height: 35px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  width: 90px;
}

.option.on .option_popup {
  display: block;
}

.Detail .comment-area {
  background: #f5f8ff;
  margin: 0 -20px;
  padding: 20px 20px 20px;
}

.Detail .comment-area h5 {
  font-size: 16px;
  font-weight: 400;
}

.Detail .comment-area h5 strong {
  color: #0086ff;
  font-weight: 500;
  padding-left: 5px
}

.Detail .comment-area ul {
}

.Detail .comment-area ul li {
  position: relative;
}

.Detail .comment-area ul li:last-child .comment-area-list {
  border-bottom: none;
  padding-bottom: 0;
}

.poll {
  margin: 20px 10px 0px;
}

.poll .poll_list {
  list-style-type: disc;
}

.poll .poll_list li {
  list-style: inherit;
  margin-bottom: 40px
}

.poll .poll_list li:last-child {
  margin-bottom: 0px
}

.poll .poll_list h4 {
  padding-right: 15px;
  font-size: 16px;
  color: #ec6464;
  font-weight: 500
}

.poll .poll_list h4 strong {
  font-weight: bold;
}

.poll .poll_list h4 small {
  font-size: 16px;
  color: #696969;
  font-weight: 300;
}

.poll .poll_list h4 small strong {
  font-size: 16px;
  color: #292929;
  font-weight: 700;
}

.poll .poll_list ul.item_list {
  list-style-type: disc;
  padding-left: 20px;
  margin: 15px 0 0 10px;
}

.poll .poll_list ul.item_list li {
  list-style: inherit;
  font-size: 16px;
}

.poll .poll_list ul.item_list li.item {
  margin: 10px 0;
}

.poll .poll_list li.poll table.vote_result {
  width: auto;
  margin: 10px 0 0 5px;
  border: 0 !important;
}

.poll .poll_list li.poll table.vote_result tr {
  border-top: none;
  border-bottom: none;
}

.poll .poll_list li.poll table tr td.name {
  padding-right: 15px;
  text-align: right;
  font-size: 16px;
}

.poll .poll_list li.poll table.vote_result tr td.bar {
  width: 150px;
}

.poll .poll_list li.poll table.vote_result tr td.bar .bg {
  background: #d8d8d8;
  border-radius: 2px;
}

.poll .poll_list li.poll table.vote_result tr td.bar .bar {
  height: 20px;
  background-color: #000;
  border: 1px solid #ccc;
  border-radius: 2px;
}

.poll .poll_list li.poll table.vote_result tr td.bar .bar.red {
  background-color: #ff8080;
  border: 1px solid #ff0080;
}

.poll .poll_list li.poll table.vote_result tr td.bar .bar.blue {
  background-color: #3399ff;
  border: 1px solid #048444;
}

.poll .poll_list li.poll table.vote_result tr td.bar .bar.green {
  background-color: #06aa3d;
  border: 1px solid #048444;
}

.poll .poll_list li.poll table.vote_result tr td.cnt {
  padding-left: 15px;
  font-size: 16px;
}

.btn-poll {
  background: #2e9cff;
  color: #fff;
  border: 0;
  padding: 10px 30px;
  font-size: 16px;
  border-radius: 5px;
  text-align: center;
}

.fileAttachment {
}

.fileAttachment li {
  margin-bottom: 10px;
  word-break: break-all;
}

.fileAttachment li a {
  display: block;
  border-radius: 5px;
  background-color: #eee;
  background-repeat: no-repeat;
  padding: 10px 50px 10px 20px;
  background-image: url("../../assets/images/down-arrow.png");
  background-size: 20px 20px;
  background-position: center right 20px;
  font-size: 15px;
  font-weight: 500;
}

.fileAttachment li a p {
  color: #737373;
  font-size: 12px;
}

.comment-area-list {
  position: relative;
  padding: 10px 0;
  border-bottom: 1px solid #dcdfe5;
}

.comment-area-list .user-photo {
  width: 42px;
  position: absolute;
  left: 0;
}

.comment-area-list .user-photo img {
  border-radius: 7px;
}

.comment-area-list .user-info {
  margin-left: 50px;
}

.comment-area-list .user-info .name {
  font-size: 16px;
  font-weight: 500;
}

.comment-area-list .date {
  color: #7a7c7f;
  letter-spacing: 0;
}

.comment-area-list .msg {
  font-size: 14px;
}

.comment-area-list .msg.on .replyContent {
  display: none
}

.comment-area-list .btn-replay {
  display: inline-block;
  background: transparent;
  color: #898a8e;
  letter-spacing: -2px;
  margin-top: 10px;
  outline: unset;
  min-width: 30px;
  text-align: left;
}

.comment-area-list .btn-replay:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.comment-area-list .like-area {
  position: absolute;
  top: 10px;
  right: 0
}

.comment-area-list .like-area .btn-like {
  background-image: url("../../assets/images/icon-like-big.png");
  color: #0086ff;
  background-color: transparent;
  font-weight: 500;
  background-repeat: no-repeat;
  background-size: 15px 14px;
  background-position: center left;
  height: 20px;
  text-align: right;
  padding-left: 20px;
  outline: unset
}

.comment-area-list .like-area .btn-like:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.comment-area ul li .replay-area li {
  border-bottom: none;
  padding: 0px 0 0;
  margin-left: 15px;
}

.comment-area .write-area {
  padding-left: 0;
  margin: 5px 0 0 0;
}

.comment-area .btn-replay + .write-area {
  display: none
}

.comment-area .btn-replay.on + .write-area {
  display: block
}

.comment-area .write-area .write-button-area {
}

.comment-area .write-area .write-button-area button {
  position: relative
}

.comment-area-list > .user-info > .msg > .write-area {
  display: none
}

.comment-area-list > .user-info > .msg > p {
  display: inline-block
}

.comment-area-list > .user-info > .msg > .replyNickName {
  margin-right: 5px
}

.comment-area-list > .user-info > .msg.on > p {
  display: none
}

.comment-area-list > .user-info > .msg.on > .write-area {
  display: block;
  padding-right: 10px
}

.replay-area .comment-area-list {
  padding: 0
}

.replay-area .comment-area-list .like-area {
  top: 0
}

.replay-area .option {
  top: 25px
}

.footer-reply {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 41px;
  border-top: 1px solid #dcdfe5;
  background: #fff;
}

.write-area {
  position: relative;
}

.write-area .user-photo {
  width: 42px;
  display: inline-block;
  vertical-align: top;
}

.write-area .user-photo img {
}

.write-area .detail-form {
  width: calc(100% - 52px);
  margin-left: 10px;
  display: inline-block;
  height: 82px;
  vertical-align: top;
}


.write-area textarea {
  width: calc(100% - 12px);
  border: 1px solid #dcdfe5;
  padding: 5px;
  min-height: 30px !important;
  height: 30px !important;
  border-radius: 5px;
}

.write-area button {
  background: transparent;
  color: #0086ff;
  font-size: 16px;
  font-weight: 500;
}

.write-area button:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

footer {
  position: fixed !important;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #dfdfdf;
  padding: 20px 10px;
  background: #fff;
  z-index: 102;
}

.page-area {
  border-top: 1px solid #dcdfe5;
  margin: 0 -20px;
  padding: 15px 20px;
}

.page-area div {
  width: 33.3333%;
  display: inline-block;
  text-align: center;
  height: 19px;
}

.page-area div button {
  background: transparent;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  width: 70%;
  position: relative;
  outline: unset
}

.page-area div button:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.page-area div button.off {
  color: #ccc;
}

.page-area div button.prev {
}

.page-area div button.prev:before {
  content: "";
  display: block;
  width: 6px;
  height: 6px;
  border-bottom: 1px solid #000;
  border-left: 1px solid #000;
  transform: rotate(45deg);
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -4px;
}

.page-area div button.off.prev:before {
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.page-area div button.next {
}

.page-area div button.next:before {
  content: "";
  display: block;
  width: 6px;
  height: 6px;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  transform: rotate(45deg);
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -4px;
}

.page-area div button.off.next:before {
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
}

.knowledgeIn {
  display: inline-block;
  margin-right: 6px;
  padding: 0 8px;
  color: #fff;
  background: #4eba39;
  font-weight: 300;
  border-radius: 3px;
  line-height: 16px;
}
</style>

